import { defaultSearchParams, hierarchyFacetKey } from '../configs';
export const updateDefaultFilters = (key, value) => {
    defaultSearchParams.filters = defaultSearchParams.filters.replace(new RegExp(`${hierarchyFacetKey.length > 0 ? `${hierarchyFacetKey}\\d` : key}:\\s*".*"`), `${key}:"${value}"`);
};
